export default function Gradient(){
    return(
        <div className="w-1/2 h-full absolute bg-gradient-to-r from-slate-600 to-slate-700 p-20"></div>
    )
}